import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import { Tab, Nav } from "react-bootstrap";
import Orderdetails from "./Orderdetails";
import Personaldetails from "./Personaldetail";
import Orderitem from "./Orderitems";
import { OrderService } from "../../../services/order-service";
import { ToastContainer } from "react-toastify";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";

export const Content = (props) => {

  const { orderID } = useParams();

  useEffect(() => {
    OrderSearchID();
  }, []);

  const [iteminfo, setItemInfo] = useState([]);
  const [isSending, setIsSending] = useState(false);

  const [orderinfo, setOrderInfo] = useState({
    id: "",
    order_id: "",
    order_sub_total: "",
    order_total_weight: "",
    order_note: "",
    order_discount: "",
    order_total: "",
    order_total_items: "",
    order_delivery_fee: "",
    order_status: "",
    order_is_reviewd: "",
    order_payment_status: "",
    order_payment_method: "",
    order_special_note: "",
    order_date: "",
    order_time_slot: "",
    order_received_time: "",
    order_preparing_started_time: "",
    order_prepared_by: "",
    order_driver_requested_time: "",
    order_bdApproved_time: "",
    order_bdApproved_by: "",
    order_dispatched_time: "",
    order_dispatched_by: "",
    order_completed_time: "",
    order_completed_by: "",
    order_cancelled_time: "",
    order_cancelled_by: "",
    order_cancelled_reason: "",
    order_created_at: "",
    order_updated_at: "",
  });

  const [userinfo, setUserInfo] = useState({
    userId: 0,
    name: "",
    email: "",
    phone: "",
    birthday: "",
    address: "",
    whatsapp_number: ""
  });

  const [deliveryinfo, setDeliveryInfo] = useState({
    delivery_name: "",
    delivery_phone1: "",
    delivery_phone2: "",
    delivery_address: "",
    delivery_city: "",
    delivery_district: "",
    delivery_province: "",
    delivery_landmark: "",
    delivery_tag: "",
    delivery_status: "",
    delivery_latitude: "",
    delivery_longitude: "",
  });

  const OrderSearchID = async () => {
    try {
    } catch (err) {
      //toast
      console.error(err);
    }
    const result = await OrderService.orderDetailsID(orderID);

    const info = {};
    const orderdata = result;
    info.id = orderdata.id;
    if(orderID == orderdata.id){
      info.order_id = orderdata.id;
    }else{
      info.order_id = orderdata.random_id;
    }
    
    info.order_sub_total = orderdata.sub_total;
    info.order_note = orderdata.note;
    info.order_discount = orderdata.discount;
    info.order_total = orderdata.total;
    info.order_delivery_fee = orderdata.delivery_fee;
    info.order_status = orderdata.status;
    info.order_is_reviewd = orderdata.is_reviewed;
    info.order_payment_status = orderdata.payment_status;
    info.order_payment_method = orderdata.payment_method;
    info.order_total_weight = orderdata.total_weight;
    info.order_special_note = orderdata.special_note;
    info.order_date = orderdata.order_date;
    info.order_time_slot = orderdata.time_slot;
    info.order_received_time = orderdata.received_time;
    info.order_preparing_started_time = orderdata.preparing_started_time;
    info.order_prepared_by = orderdata.prepared_by;
    info.order_driver_requested_time = orderdata.driver_requested_time;
    info.order_bdApproved_time = orderdata.bdApproved_time;
    info.order_bdApproved_by = orderdata.bdApproved_by;
    info.order_dispatched_time = orderdata.dispatched_time;
    info.order_dispatched_by = orderdata.dispatched_by;
    info.order_completed_time = orderdata.completed_time;
    info.order_completed_by = orderdata.completed_by;
    info.order_cancelled_time = orderdata.cancelled_time;
    info.order_cancelled_by = orderdata.cancelled_by;
    info.order_cancelled_reason = orderdata.cancelled_reason;
    info.order_created_at = orderdata.created_at;
    info.order_updated_at = orderdata.updated_at;

    info.userId = orderdata.user.id;
    info.name = orderdata.user.name;
    info.email = orderdata.email;
    info.phone = orderdata.user.phone;
    info.birthday = orderdata.user.birthday;
    info.whatsapp_number = orderdata.user.whatsapp_number;
    info.address = orderdata.user.address;
    info.created_at = orderdata.user.created_at;
    info.updated_at = orderdata.user.updated_at;

    info.delivery_name = removeLastWord(orderdata.name);
    info.delivery_phone1 = removeLastWord(orderdata.phone1);
    info.delivery_phone2 = removeLastWord(orderdata.phone2);
    info.delivery_address = removeLastWord(orderdata.delivery_address);
    info.delivery_city = orderdata.city;
    if(orderdata.districtId){
      info.delivery_district = orderdata.districtId;
    }else{
      info.delivery_district = '';
    }
    
    info.delivery_province = orderdata.province;
    info.delivery_landmark = "";
    info.delivery_tag = "";
    info.delivery_status = "";
    info.delivery_latitude = "";
    info.delivery_longitude = "";

    setOrderInfo(info);
    setUserInfo(info);
    setDeliveryInfo(info);
    setItemInfo(orderdata.items);
  };

  const removeLastWord = (address) => {
    // Split the address by spaces, remove the last word, and join it back together
    return address.replace(/,\s*\w+$/, '');
  }

  const handleClick = async () => {
    setIsSending(true);

    try {
      const response = await OrderService.sendReviewSms(orderID);
      if(response.status == "success"){
        notify("SMS sent successfully");
      }else{
        setIsSending(false);
        notifyWarning("Error sending SMS");
      }
    } catch (error) {
      console.error("Error sending SMS:", error);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <div className="row">
                <div className="col-sm-6">
                  <h6>Edit Order Details</h6>
                </div>
                <div className="col-sm-6">
                  {orderinfo.order_status === "PENDING" ? (
                    <div
                      className="alert alert-warning alert-solid"
                      role="alert"
                    >
                      <strong>PENDING ORDER</strong>
                    </div>
                  ) : orderinfo.order_status === "PREPARING" ? (
                    <div
                      className="alert alert-dark alert-solid"
                      role="alert"
                    >
                      <strong>READY TO SHIPPED ORDER</strong>
                    </div>
                  ) :  orderinfo.order_status === "DELIVERING" ? (
                    <div
                      className="alert alert-info alert-solid"
                      role="alert"
                    >
                      <strong>SHIPPED ORDER</strong>
                    </div>
                  ) : orderinfo.order_status === "COMPLETED" ? (
                    <div
                      className="alert alert-success alert-solid"
                      role="alert"
                    >
                      <strong>COMPLETED ORDER</strong>
                    </div>
                  ) : orderinfo.order_status === "CANCELED" ? (
                    <div className="alert alert-danger alert-solid" role="alert">
                      <strong>CANCELED ORDER</strong>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                {/*<div className="col-sm-3">
                 {orderinfo.order_status === "COMPLETED" && orderinfo.order_is_reviewd === false ? (
                    <button
                      type="button"
                      className="btn btn-dark shadow-none"
                      disabled={isSending}
                      onClick={handleClick}
                    >
                      Send Review&nbsp;<i class="fa fa-paper-plane" aria-hidden="true"></i>
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-dark shadow-none"
                      disabled={true}
                      
                    >
                      Send Review&nbsp;<i class="fa fa-paper-plane" aria-hidden="true"></i>
                    </button>
                  )} 
                </div>*/}
              </div>
            </div>
            <div className="ms-panel-body clearfix">
              <Tab.Container defaultActiveKey="tab13">
                <Nav
                  variant="tabs"
                  className="nav nav-tabs d-flex nav-justified mb-4"
                >
                  <Nav.Item>
                    <Nav.Link eventKey="tab13">Order Details</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="tab14">Personal Details</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="tab15">Order Items</Nav.Link>
                  </Nav.Item>
                  {/* <Nav.Item>
                    <Nav.Link eventKey="tab16">Delivery Location</Nav.Link>
                  </Nav.Item> */}
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="tab13">
                    <Orderdetails
                      id={orderinfo.id}
                      order_id={orderinfo.order_id}
                      sub_total={orderinfo.order_sub_total}
                      note={orderinfo.order_note}
                      discount={orderinfo.order_discount}
                      total={orderinfo.order_total}
                      delivery_fee={orderinfo.order_delivery_fee}
                      status={orderinfo.order_status}
                      payment_status={orderinfo.order_payment_status}
                      payment_method={orderinfo.order_payment_method}
                      total_weight={orderinfo.order_total_weight}
                      special_note = {orderinfo.order_special_note}
                      order_date={orderinfo.order_date}
                      received_time={orderinfo.order_received_time}
                      preparing_started_time={
                        orderinfo.order_preparing_started_time
                      }
                      prepared_by={
                        orderinfo.order_prepared_by
                      }
                      bdApproved_time={orderinfo.order_bdApproved_time}
                      bdApproved_by={orderinfo.order_bdApproved_by}
                      dispatched_time={orderinfo.order_dispatched_time}
                      dispatched_by={orderinfo.order_dispatched_by}
                      completed_time={orderinfo.order_completed_time}
                      completed_by={orderinfo.order_completed_by}
                      cancelled_time={orderinfo.order_cancelled_time}
                      cancelled_by={orderinfo.order_cancelled_by}
                      cancelled_reason={orderinfo.order_cancelled_reason}
                      created_at={orderinfo.order_created_at}
                      updated_at={orderinfo.order_updated_at}
                      
                      OrderSearchID = {OrderSearchID}

                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="tab14">
                    <Personaldetails
                      id={orderinfo.id}
                      userId={userinfo.userId}
                      name={userinfo.name}
                      birthday={userinfo.birthday}
                      email={userinfo.email}
                      phone={userinfo.phone}
                      whatsapp_number={userinfo.whatsapp_number}
                      created_at={userinfo.created_at}
                      updated_at={userinfo.updated_at}
                      delivery_name={deliveryinfo.delivery_name}
                      delivery_phone1={deliveryinfo.delivery_phone1}
                      delivery_phone2={deliveryinfo.delivery_phone2}
                      delivery_address={
                        deliveryinfo.delivery_address
                      }
                      delivery_city={deliveryinfo.delivery_city}
                      delivery_district={deliveryinfo.delivery_district}
                      delivery_province={deliveryinfo.delivery_province}
                      // delivery_landmark={deliveryinfo.delivery_landmark}
                      // delivery_tag={deliveryinfo.delivery_tag}
                      delivery_status={deliveryinfo.delivery_status}
                      status = {orderinfo.order_status}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="tab15">
                    <Orderitem iteminfo={iteminfo} />
                  </Tab.Pane>
                  {/* <Tab.Pane eventKey="tab16">
                    <Deliverylocation
                      delivery_latitude={deliveryinfo.delivery_latitude}
                      delivery_longitude={deliveryinfo.delivery_longitude}
                    />
                  </Tab.Pane> */}
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
